import React from 'react';
import { withRouter } from 'react-router-dom';
import { get, isEmpty } from 'lodash';
import queryString from 'query-string';
import shortid from 'shortid';
import * as backRoute from 'utils/backRoute';

// local dependencies
import { DASHBOARD } from 'constants/route-paths';
import { MemberOrderDetailService } from 'services/memberOrderDetail';
import { memberOrderDetail as MemberOrderDetailView } from 'ui/views/widgets/memberOrderDetail';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';
import { messageBus as MessageBus } from 'core/modules/message-bus';
import * as MESSAGE_BUS_EVENTS from 'constants/message-bus-events';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberOrderDetail } from 'ui/containers/MemberOrderDetail';
 *
 * // render
 * <MemberOrderDetail propName='propValue'/>
 */
class _MemberOrderDetail extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // check if URL container `memberId` query parameter.
        const queryParams = queryString.parse( this.props.location.search );
        const memberId = get( this.props.location, 'state.memberId', undefined );
        const patientId = get( this.props.location, 'state.patientId', undefined );

        this.handleNavActionClick = this.handleNavActionClick.bind( this );
        this.refreshOrderDetails = this.refreshOrderDetails.bind( this );

        this.state = {
            isFetching: true,
            networkStatus: undefined,
            memberId: memberId,
            orderId: get( queryParams, 'orderId' ),
            componentData: undefined,
            refreshKey: shortid.generate(),
            patientId: patientId,
        };

        // create service instance
        this.memberOrderDetailService = new MemberOrderDetailService();

        // previously if - `memberId` is not present, redirect to the dashboard landing
        // else - make service request for the component data
        // (isEmpty( this.state.memberId ) ||  isEmpty( this.state.orderId ))
        //if - `patientId` is not present, redirect to the dashboard landing
        if( isEmpty( this.state.patientId ) ||  isEmpty( this.state.orderId ) ) {
            this.props.history.replace( DASHBOARD );
        } else {
            this.fetchComponentData(); // start component data fetch
        }
    }

    /**
         * @desc When component mounts, add MessageBus event listeners.
         */
    componentDidMount() {
        log.debug( 'MemberOrderDetail.componentWillMount()' );

        MessageBus.on( MESSAGE_BUS_EVENTS.ORDER_DETAIL_REFRESH, this.refreshOrderDetails, this );
    }

    /**
     * @desc: refresh the page
     */
    refreshOrderDetails() {
        log.debug( 'MemberOrderDetail.refreshOrderDetails()' );

        this.setState( { isFetching: true }, () => {
            this.fetchComponentData();
        } );
    }

    /**
     * @desc: fetch widgte sequence list
     */
    async fetchComponentData() {
        log.debug( 'MemberOrderDetail.fetchComponentData()' );

        // cancel ongoing request
        this.memberOrderDetailService.cancel();

        // get status and service data
        const { status, data } = await this.memberOrderDetailService.fetchComponentData( {
            url: this.props.widget.url,
            data: {
                data: {},
                context: {
                    memberId: this.state.memberId,
                    orderId: this.state.orderId,
                }
            }
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            }, () => {

            } );
        }
    }

    handleNavActionClick( { type, value } ) {
        log.debug( 'MemberOrderDetail.handleNavActionClick()' );

        if( 'headerAction' === type && 'back' === value.name ) {

            // get back-route payload
            const backRoutePayload = backRoute.decode( this.props.location );

            if( ! isEmpty( backRoutePayload ) ) {
                return this.props.history.push( backRoutePayload );
            } else {
                this.props.history.push( {
                    pathname: DASHBOARD_SUB_ROUTES.MEMBER_MANAGEMENT,
                    state: {  memberId: this.state.memberId }
                } );
            }

            // this.props.history.goBack();
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.memberOrderDetailService.cancel(); // cancel ongoing requests

        MessageBus.off( MESSAGE_BUS_EVENTS.ORDER_DETAIL_REFRESH, this.refreshOrderDetails, this );
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberOrderDetailView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                memberId={ this.state.memberId }
                refreshKey={ this.state.refreshKey }
                { ...get( this.state, 'componentData', {} ) }
                requestPayload = { {
                    context: {
                        memberId: this.state.memberId,
                        orderId: this.state.orderId
                    }
                } }
                onNavActionClick={ this.handleNavActionClick }
            />
        );
    }
}

// set display name
_MemberOrderDetail.displayName = 'MemberOrderDetail';

// set default props
_MemberOrderDetail.defaultProps = {};

// prop types
_MemberOrderDetail.propTypes = {};

export const MemberOrderDetail = withRouter( _MemberOrderDetail );
